// SOẠN KHÔNG NHẮC SẢN PHẨM (2026-10-03, Reddit "tìm rồi bình luận"): cộng đồng có luật cấm quảng cáo / tự quảng bá ("No self-promotion",
// "No advertising"…) → câu AI soạn cho bài ở đó KHÔNG được nhắc sản phẩm. Khối đánh dấu bằng `generate.guide` bắt đầu bằng KHONG_SAN_PHAM
// (chuỗi — schema DSL đã nhận mọi chuỗi ở guide, nên bundle vẫn hợp lệ với plugin cũ):
//  - plugin mới: dùng knowledge của kịch bản NHƯNG bỏ hồ sơ/tài liệu sản phẩm + mục tiêu quảng bá, che tên sản phẩm trong giọng điệu/cấm kỵ,
//    thêm lời dặn ở phần sau dấu đánh dấu; lớp kiểm TẤT ĐỊNH chặn câu có tên sản phẩm (soạn lại 1 lần, vẫn có → bỏ mục);
//  - plugin cũ (chưa biết dấu này): cả chuỗi thành giọng điệu, KHÔNG có hồ sơ sản phẩm → AI không biết sản phẩm là gì (an toàn, chỉ kém giọng).
// Thuần (không I/O) — runner + test dùng chung.
import { normText } from "./vi";

export const KHONG_SAN_PHAM = "[khong_san_pham]";

export function laGuideKhongSanPham(guide: unknown): guide is string {
  return typeof guide === "string" && guide.startsWith(KHONG_SAN_PHAM);
}

/** Tên sản phẩm của kịch bản: dòng "Tên: X" của knowledge.san_pham, hoặc ten của bản chụp thư viện (san_pham_thu_vien). Không có → []. */
export function tenSanPham(k: Record<string, unknown> | undefined): string[] {
  const out = new Set<string>();
  const sp = typeof k?.san_pham === "string" ? k.san_pham : "";
  const m = /^\s*Tên:\s*(.+?)\s*$/m.exec(sp);
  if (m?.[1]) out.add(m[1]);
  if (typeof k?.san_pham_thu_vien === "string") {
    try { const t = (JSON.parse(k.san_pham_thu_vien) as { ten?: unknown }).ten; if (typeof t === "string" && t.trim()) out.add(t.trim()); } catch { /* bản chụp hỏng → bỏ */ }
  }
  return [...out].filter((x) => normText(x).trim().length >= 2);
}

const thoatRe = (s: string): string => s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
function che(s: string, ten: string[]): string {
  let t = s;
  for (const x of ten) t = t.replace(new RegExp(thoatRe(x), "giu"), "(sản phẩm)");
  return t;
}

/** Knowledge cho câu KHÔNG nhắc sản phẩm: bỏ hồ sơ/tài liệu/mục tiêu, che tên sản phẩm, thêm lời dặn (phần sau dấu đánh dấu, đã render). */
export function knowledgeKhongSanPham(k: Record<string, unknown> | undefined, loiDan: string): Record<string, unknown> {
  const goc = k ?? {};
  const ten = tenSanPham(goc);
  const { san_pham: _sp, tai_lieu: _tl, san_pham_thu_vien: _tv, ho_so_id: _hs, muc_tieu: _mt, ...con } = goc;
  const dan = loiDan.trim() || "Cộng đồng này cấm quảng cáo / tự quảng bá: TUYỆT ĐỐI không nhắc, không ám chỉ sản phẩm, dịch vụ, thương hiệu hay liên kết nào của mình.";
  const gd = typeof con.giong_dieu === "string" && con.giong_dieu.trim() ? `${che(con.giong_dieu, ten)}\n${dan}` : dan;
  const cam = (Array.isArray(con.cam_ky) ? (con.cam_ky as unknown[]).map(String) : []).map((c) => che(c, ten));
  return { ...con, giong_dieu: gd, cam_ky: [...cam, "Không nhắc tên hay ám chỉ sản phẩm/dịch vụ của mình (cộng đồng cấm quảng cáo / tự quảng bá)"] };
}

/** Câu soạn có nhắc tên sản phẩm (so không dấu, không phân biệt hoa thường, theo ranh giới chữ) → lý do; không → null. */
export function nhacTenSanPham(text: string, ten: string[]): string | null {
  const t = ` ${normText(text)} `;
  for (const x of ten) {
    const n = normText(x).trim();
    if (!n) continue;
    if (new RegExp(`(^|[^\\p{L}\\p{N}])${thoatRe(n)}([^\\p{L}\\p{N}]|$)`, "u").test(t)) return `nhắc tên sản phẩm “${x}” ở cộng đồng cấm quảng cáo / tự quảng bá — viết lại KHÔNG nhắc sản phẩm`;
  }
  return null;
}

// Luật cộng đồng (chữ thanh bên / mục Rules của Reddit) cấm quảng cáo / tự quảng bá. Dùng trong extract (phan_loai) — regex KHÔNG có cờ i
// (phan_loai dựng new RegExp(re) không cờ) nên viết cả hoa/thường bằng lớp ký tự. Bắt: "No self-promotion", "No promotion", "No advertising",
// "No ads", "self-promotion" (mọi câu nhắc tới tự quảng bá trong luật), "Cấm/Không quảng cáo/quảng bá", "tự quảng bá/tự PR".
const ci = (s: string): string => s.split("").map((c) => (/[a-z]/i.test(c) ? `[${c.toLowerCase()}${c.toUpperCase()}]` : c === " " ? "[\\s-]*" : thoatRe(c))).join("");
export const RE_LUAT_CAM_QC = [
  `\\b${ci("no")}[\\s-]*(?:${ci("self")}[\\s-]*)?(?:${ci("promo")}|${ci("advertis")}|${ci("ads")}\\b)`,
  `\\b${ci("self")}[\\s-]*${ci("promo")}`,
  `(?:[Cc]ấm|[Kk]hông)\\s*(?:được\\s*)?(?:[Qq]uảng\\s*cáo|[Qq]uảng\\s*bá|PR\\b)`,
  `[Tt]ự\\s*(?:[Qq]uảng\\s*(?:bá|cáo)|PR\\b)`,
].join("|");
